import { registerMutation, useMutation } from 'data-fetching-client';
import { useCallback } from 'react';
import { GET_TICKET } from './useTicket';
import { GET_TICKET_LISTING_KEY } from './useTicketListings';
import { GET_TICKET_LISTINGS_SEARCH_KEY } from './useTicketListingsSearch';
import { SEARCH_TICKETS_FOR_NAVIGATION_QUERY_FIELD_NAME } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.dfc.new';
import { closeTicketRpc } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc';
import { chirpClient } from '../utils/chirpClient';
const closeTicket = async ({
  id
}) => {
  await chirpClient.call(closeTicketRpc, {
    request: {
      params: {
        ticketId: id
      }
    }
  });
  return {
    id,
    status: 'CLOSED'
  };
};
const CLOSE_TICKET_MUTATION_FIELD_NAME = 'closeTicket';
const CLOSE_TICKET_MUTATION = registerMutation({
  fieldName: CLOSE_TICKET_MUTATION_FIELD_NAME,
  fetcher: closeTicket,
  args: ['id']
});
export const useCloseTicket = () => {
  const [mutate, {
    loading,
    called,
    error
  }] = useMutation(CLOSE_TICKET_MUTATION, {
    refetchQueries: [GET_TICKET],
    awaitRefetchQueries: true,
    update: cache => {
      cache.evict({
        fieldName: GET_TICKET_LISTING_KEY
      });
      cache.evict({
        fieldName: GET_TICKET_LISTINGS_SEARCH_KEY
      });
      cache.evict({
        fieldName: SEARCH_TICKETS_FOR_NAVIGATION_QUERY_FIELD_NAME
      });
      cache.gc();
    }
  });
  const handleCloseTicket = useCallback(id => {
    mutate({
      variables: {
        id
      }
    }).catch(() => {});
  }, [mutate]);
  return {
    closeTicket: handleCloseTicket,
    isTicketClosing: loading,
    isCompleted: called && !loading,
    error
  };
};